<template>
  <div class="home" id="banner">
    <banner-Component></banner-Component>
   <div class="main">
<!--    关于我们-->
       <div class="about" id="about">
           <div class="title wow fadeInUp">
               <p>{{$t('home').about.text0}}</p>
               <p>{{$t('home').about.text1}}</p>
               <p>{{$t('home').about.text2}}</p>
           </div>
             <div class="content">
                 <div class="l wow fadeInLeft">
                     <img src="../assets/zy/l.png" alt="">
                 </div>
                 <div class="nr wow fadeInUp">
                     <p>{{$t('home').about.text3}}</p>
                     <aboutDia3 />
<!--                     <p>{{$t('home').about.text4}}</p>-->
                 </div>
                 <div class="right wow">
                     <img src="../assets/zy/ar.png" alt="">
                     <span @click="playVideo">
                   <i class="iconfont icon-bigbofang"></i>
               </span>
                 </div>
             </div>
           <div class="allNums wow fadeInUp">
               <div class="threeNum" ref="counts">
                   <div class="item">
                       <div class="num">
                           <span id="num1">2000</span>
                           <span>㎡</span>
                       </div>
                       <p>{{$t('home').about.text5}}</p>
                   </div>
                   <div class="item">
                       <div class="num">
                           <span id="num2">130</span>
                           <span>+</span>
                       </div>
                       <p>{{$t('home').about.text6}}</p>
                   </div>
                   <div class="item">
                       <div class="num">
                           <span id="num3">200</span>
                           <span>+</span>
                       </div>
                       <p>{{$t('home').about.text7}}</p>
                   </div>
                   <div class="item">
                       <div class="num">
                           <span id="num4">20</span>
                           <span>+</span>
                       </div>
                       <p>{{$t('home').about.text8}}</p>
                   </div>
               </div>
           </div>
           <div class="btns wow fadeInUp">
               <div class="btn" @click="gotoAbout">
                   {{$t('btn')}}
               </div>
               <p>High Performance, Full Satisfaction</p>
           </div>
       </div>

<!--       产品中心-->
       <mpro />
       <!-- 行业应用 -->
        <application />
<!--       新闻中心-->
       <news  />

       <customer class="wow zoomIn"  />
   </div>

      <div class="video-full"   :class="{ showVideo }" >
          <div class="video-content">
              <div class="video-close"
                   @click="pauseVideo">
                  <i class="el-icon-close"></i>
              </div>
              <video
                      id="videoPlay01"
                      controls="controls"
                      style="z-index: 3000">
                  <source
                          type="video/mp4;"
                          src="//www.dhkbearing.com/uploads/dake.mp4"
                          data-src="//www.dhkbearing.com/uploads/dake.mp4">

                  你的浏览器不支持
                  <code>video</code> 标签.
              </video>
          </div>
      </div>
      <foot-Component class="foot wow fadeIn" ></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import { CountUp } from 'countup.js'
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import footComponent from '../components/foot'
  import aboutDia3 from '../components/aboutDia3'
  import mpro from '../components/mpro'
  import application from '../components/application'
  import news from '../components/news'
  import customer from '../components/customer'
  import { getProductsUrl} from '../util/lang'
export default {
  name: 'home',
    data(){
      return{
          showVideo:false,
          list:[],
          scrollbar:'',
          pList:[],
          nList:[],
          swiperOption:{
              slidesPerView: 1,
              speed:1000,
              spaceBetween : 20,
              navigation: {
                  nextEl: '.left .btns .next',
                  prevEl: '.left .btns .prev'
              }
          },
          swiperOption2:{
              slidesPerView: 1,
              speed:1000,
              navigation: {
                  nextEl: '.allImgs .next',
                  prevEl: '.allImgs .prev'
              }
          },
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
        setTimeout(()=>{
            // this.getList('2')
            this.count()
        },100)
    },
  components:{bannerComponent,footComponent,swiper, swiperSlide,mpro,news,customer,aboutDia3,application},
    methods:{
        pauseVideo(){
            Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#about"),{
                offsetTop:125,
            })
            const audioPlayer = window.document.getElementById('videoPlay01');
            audioPlayer.pause();
            this.showVideo=false
        },
        playVideo(){
            Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#banner"))
            const audioPlayer = window.document.getElementById('videoPlay01');
            audioPlayer.load();
            audioPlayer.play();
            this.showVideo=true
        },
        getList(id){
            const url = `${getProductsUrl(id)}`
            this.$axios.get(url).then(res => {
                this.list=res.data.data
            })
        },
        gotoInfo(n){
            const link=`/newsInfo.html?id=${n}`
            window.open(link,'_blank')
        },
        getNews(id){
            const url = `${getNewsUrl('zh-CN',id,1000,1)}`
            this.$axios.get(url).then(res => {
                res.data.newsArr.map((item)=>{
                    item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    if(item.ISCOMMEND==='1'){
                        this.nList.push(item)
                    }
                })
            })
        },
        count(){
            let element=this.$refs.counts;
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (element=element.offsetParent){
                actualTop += element.offsetTop;
                /* current = current.offsetParent; */
            }
            let demoFi1 = new CountUp("num1", 15000);
            let demoFi2 = new CountUp("num2", 30);
            let demoFi3 = new CountUp("num3", 20);
            let demoFi4 = new CountUp("num4", 20);
            // demoFi1.start();
            // demoFi2.start();
            // demoFi3.start();
            let numok=false;
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            if(scrollbar){
                scrollbar.addListener((status) => {
                    if(!numok){
                        if(actualTop<status.offset.y+document.body.clientHeight){
                            demoFi1.start();
                            demoFi2.start();
                            demoFi3.start();
                            demoFi4.start();
                            numok=true;
                        }
                    }
                });
            }
        },
        gotoAbout(){
            const link='/intodhk.html'
            window.open(link,'_self')
        },
     change(n){
       this.select=n
     }
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    overflow: hidden;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
  .main{
    width:100%;
   .about{
       width:100%;
       position: relative;
       .title{
           width:1440px;
           margin: 60px auto;
               p:nth-child(1){
                   color:#333333;
                   font-family: "DINEngschriftStd";
                   font-size: 50px;
                   text-transform: uppercase;
               }
               p:nth-child(2){
                   color:#333333;
                   font-size: 25px;
                   font-family: "SourceHanSansSC-Regular";
                   display: flex;
                   flex-direction: column;
                   &::after{
                       content:'';
                       display: inline-block;
                       width:44px;
                       height:5px;
                       background:#FECD4A;
                       margin-top: 10px;
                   }
               }
               p:nth-child(3){
                   font-size: 20px;
                   color:#333333;
                   font-family: "SourceHanSansSC-Medium";
                   font-weight: bold;
                   margin-top: 20px;
               }
       }
       .content{
           width:100%;
           margin: 0 auto;
           display: flex;
           flex-direction: row;
           position: relative;
           .l{
               width:10%;
           }
           .nr{
               width:50%;
               background-color: #FCFCF9;
               padding: 60px 0;
               position: absolute;
               left:12%;
               top:0;
               z-index: 100;
               border-radius: 10px;
               p{
                   width:80%;
                   margin: 0 auto;
               }
               p:nth-child(1){
                   color:#333333;
                   font-family: "SOURCEHANSANSCN-HEAVY";
                   font-size: 30px;
                   margin: 30px auto;
               }
               p:nth-child(2){
                   font-family: "SOURCEHANSANSCN-LIGHT";
                   line-height: 36px;
               }
           }
           .right{
               width:45%;
               position: absolute;
               right:0;
               top:-70px;
               cursor: pointer;
               overflow: hidden;
               animation:polygon 1s  forwards linear  ;
               img{
                   width:100%;
                   display: block;
                   object-fit: cover;
                   height:100%;
                   transition: all 600ms;
               }
               &:hover{
                   img{
                       transform: scale(1.2);
                   }
               }
               span{
                   position: absolute;
                   top:42%;
                   left:48%;
                   display: inline-block;
                   animation: rotate 2s linear infinite;
                   i{
                       color:white;
                       font-size: 60px;
                       transition: all 600ms;
                   }
                   &:hover{
                       i{
                           color:#F6C02E;
                       }
                   }
               }
               @keyframes rotate {
                   from{
                       transform: rotate(0);
                   }
                   to{
                       transform: rotate(360deg);
                   }
               }
           }
       }
       .allNums{
           width:1440px;
           margin: 0 auto;
           .threeNum{
               width:50%;
               display: flex;
               flex-direction: row;
               justify-content: center;
               .item{
                   width:25%;
                   .num{
                       position: relative;
                       span:nth-child(1){
                           font-size: 40px;
                           font-family: "os";
                           display: inline-block;
                           width:100%;
                           text-align: center;
                       }
                       span:nth-child(2){
                           position: absolute;
                           right:20%;
                           top:0;
                           font-family: "DINEngschriftStd";
                           font-size: 25px;
                           color:#333333;
                           text-transform: uppercase;

                       }
                   }
                   p{
                       color:#333333;
                       font-family: "AdobeHeitiStd-Regular";
                       text-align: center;
                   }
               }
               .item:nth-child(1){
                   .num{
                       span:nth-child(2){
                           right:2%;
                       }
                   }
               }
           }
       }
       .btns{
           width:1440px;
           margin: 40px auto;
           position: relative;
           .btn{
               width:160px;
               height:50px;
               background:#F6C02E;
               border-radius:15px;
               box-shadow: 5px 7px 38px 0px rgba(224,179,59,0.6);
               text-align: center;
               line-height: 50px;
               color:white;
               font-family: "SOURCEHANSANSCN-LIGHT";
               cursor: pointer;
               transition: all 600ms;
              margin: 0 auto;
               &:hover{
                   box-shadow:6px 8px 38px 0px rgba(155,124,43,0.5);
               }
           }
           p{
               position: absolute;
               right:0;
               top:-30px;
               text-transform: uppercase;
               color:#333333;
               font-family: "it";
               font-size: 30px;
           }
       }
   }
  }
    .foot{
      animation-duration: 5s;
    }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
        clip-path: polygon(0 0,0 100%,0 100%,0 0);
        opacity: 0;
    }
    100% {
        clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
        opacity: 1;
    }
  }

  @media screen and (max-width: 1440px){
  .main{
   .about{
      .title,.allNums,.btns{
          width:90%;
      }
       .allNums{
           .threeNum{
               width:60%;
           }
       }
       .btns{
           p{
               top: -119px;
               font-size: 25px;
           }
       }
   }
  }
  }
  @media screen and (max-width: 1000px){
      .main{
          .about{
              .title{
                  margin: 30px auto;
                  p:nth-child(1){
                      font-size: 32px;
                  }
              }
              .content{
                  flex-direction: column;
                  .l{
                      display: none;
                  }
                  .nr{
                      position: static;
                      width:100%;
                      padding: 30px 0;
                      padding-top: 0;
                      p{
                          width:90% !important;
                      }
                  }
                  .right{
                      position: relative;
                      top:0;
                      width:100%;
                      span{
                          top:30%;
                          left:40%;
                      }
                  }
              }
              .allNums{
                  margin-top: 30px;
                  .threeNum{
                      width:100%;
                      flex-wrap: wrap;
                      .item{
                          width:50%;
                      }
                  }
              }
              .btns{
                  margin-top: 30px;
                  p{
                      position: static;
                      margin-top: 30px;
                      text-align: center;
                      font-size: 22px;
                  }
              }
          }
      }
  }
}
</style>
<style scoped>
    video{
        border: none;
    }
    video:focus{
        outline: none;
    }
    .video-full {
        display: none;
    }
    .video-full.showVideo {
        display: block;
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 10000;
    }
    .video-bg {
    }
    .video-close {
        cursor: pointer;
        position: absolute;
        top: 10%;
        right: 20%;
        z-index: 3200;
    }
    .video-close i {
        transition: opacity 0.4s ease-in-out;
        font-size: 50px;
        color: #fff;
    }
    .video-content {
        margin: 150px auto;
        z-index: 3000;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1024px;
        min-height: 660px;
        max-height: 90vh;
    }
    .video-content video {
        width: 100%;
        height: 100%;
    }
    @media screen and (max-width: 1440px) and (min-width: 1000px){
        .video-content{
            margin: 70px auto;
        }
        .video-close{
            top:5%;
            right:10%;
        }
    }
    @media screen and (max-width: 1000px){
        .video-content{
            margin: 70px auto;
            width:90%;
        }
        .video-close{
            top:5%;
            right:10%;
        }
    }
    @media screen and (max-width: 1024px) {
        .home .main .about .content .right span {

            animation: unset !important;
        }
        .home .main .about .title p:nth-child(3) {
            display: none;
        }
        .home .main .about .content .nr p:nth-child(1) {
            display: none;
        }
        .home .main .about .btns p {
            display: none;
        }
    }
</style>
